<template>
  <div>
    <el-dialog title="家庭成员列表" width="70%" @close="setDialogClose" center :close-on-click-modal="false"
      :visible.sync="showDialog" append-to-body>
      <el-container direction="vertical">
        <el-row>
          <el-button style="margin-left:5px;" size="mini" type="primary" @click="addContact">+新建联系人</el-button>
          <el-button style="margin-left:5px;" size="mini" type="primary" @click="addContactOnline">在线添加联系人</el-button>
        </el-row>

        <el-row style="margin-top: 20px;">
          <el-table v-loading="listLoading" :data="relationData" border fit highlight-current-row
            style="width: 100%; margin-top: 10px" size="mini">
            <el-table-column align="center" label="创建时间">
              <template slot-scope="scope">
                <span>{{ getStandardDate(scope.row.createTime) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="关系">
              <template slot-scope="scope">
                <span>{{ scope.row.relationName }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="联系电话">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button style="margin-left: 0px; align-self: center" type="text" @click="patientsDetail(scope.row)">
                  查看
                </el-button>

                <el-button style="margin-left: 5px; align-self: center" type="text" @click="patientsEdit(scope.row)">
                  编辑
                </el-button>

                <el-button style="margin-left: 5px; align-self: center" type="text"
                  @click="delContactPatient(scope.row)">
                  删除
                </el-button>

                <el-button style="margin-left: 5px; align-self: center" type="text"
                  @click="updatePatientsEdit(scope.row)">
                  更新
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-container>

      <pagination v-show="total > 0" :total="total" :page.sync="formData.pageNum" :limit.sync="formData.pageSize"
        @pagination="turnToPage" />

      <edit-patient :pInfo="pInfo" v-if="editPatientVisible" ref="editPatientRef"></edit-patient>

      <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>

      <edit-contact-patient @update="update" v-if="editContactPatientVisiable"
        ref="editContactPatientRef"></edit-contact-patient>

      <add-contact-patient @update="update" v-if="addContactPatientVisible"
        ref="addContactPatientRef"></add-contact-patient>

      <addOnlineContact @updateHomeList="update" :pInfo="pInfo" v-if="addOnlineContactVisiable"
        ref="addOnlineContactRef">
      </addOnlineContact>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import addContactPatient from "@/views/patient/addContactPatient";
import addOnlineContact from "@/views/patient/addOnlineContact";
import editContactPatient from "@/views/patient/editContactPatient";
import contactPatientDetail from "@/views/patient/contactPatientDetail";
import editPatient from "@/views/patient/editPatient";
import patientDetail from "@/views/patient/patientDetail";
import { getContactList, delContactList, turnToContactList, getByIdPatientDetail, getSearchList } from "@/api/health/Patients";
import pagination from "@/components/Pagination";
import moment from "moment";


export default {
  components: {
    contactPatientDetail,
    addContactPatient,
    pagination,
    editPatient,
    patientDetail,
    editContactPatient,
    addOnlineContact
  },
  data() {
    return {
      pInfo: null,
      showDialog: false,
      editPatientVisible: false,
      contactPatientDetailVisible: false,
      addContactPatientVisible: false,
      patientDetailVisible: false,
      editContactPatientVisiable: false,
      addOnlineContactVisiable: false,
      showClose: false,
      listLoading: false,
      relationData: [],
      total: 0,
      formData: {
        pageNum: 1,
        pageSize: 10,
        householderIdcard: null,
      },
    };
  },
  created() {
    console.log("===========数据========", this.pInfo)
  },
  methods: {
    // 初始化页面
    async init(value) {
      console.log("家庭成员pinfo:", value);
      this.pInfo = value;
      this.getList();
      this.showDialog = true;
    },
    setDialogClose() {
      this.showDialog = false;
    },
    addContactOnline() {
      this.addOnlineContactVisiable = true;
      this.$nextTick(() => {
        this.$refs["addOnlineContactRef"].init(this.pInfo);
      });
    },
    // 获取家庭联系人列表
    getList() {
      this.formData.householderIdcard = this.pInfo.idcard;
      this.listLoading = true;
      getContactList(this.formData).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.relationData = res.data.records;
          console.log("家庭联系人列表", this.relationData);
          this.total = res.data.total;
        }
      });
    },
    // 打开添加联系人弹窗
    addContact() {
      this.addContactPatientVisible = true;
      this.$nextTick(() => {
        this.$refs.addContactPatientRef.init(this.pInfo)
      })
    },
    // 更新联系人健康档案
    updatePatientsEdit(row) {
      if (row.healthNo != null) {
        this.$confirm('该患者已经建立家庭联系人档案，请点击编辑后查看患者家庭联系人档案！', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          type: 'warning'
        })
      } else {
        this.editContactPatientVisiable = true;
        this.$nextTick(() => {
          this.$refs.editContactPatientRef.init(row);
        })
      }
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      // 判断有无档案号个人信息去判断是否完成新的档案建立
      if (row.healthNo == null) {
        this.$confirm('该患者尚未建立家庭联系人档案，请点击更新，建立家庭联系人档案后查看！', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          type: 'warning'
        })
      } else {
        let params = {
          healthNo: row.healthNo
        }
        getSearchList(params).then((res) => {
          if (res.msg == "success") {
            console.log("========", res, row)
            var data = res.data.records[0];
            this.patientDetailVisible = true;
            this.$nextTick(() => {
              this.$refs["PatientDetailRef"].init(data);
            });
          }
        }).catch((error) => {
          console.log(error);
        })
      }
    },
    // 编辑个人档案
    patientsEdit(row) {
      if (row.healthNo == null) {
        this.$confirm('该患者尚未建立家庭联系人档案，请点击更新，建立家庭联系人档案后查看！', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          type: 'warning'
        })
      } else {
        let params = {
          healthNo: row.healthNo
        }
        getSearchList(params).then((res) => {
          if (res.msg == "success") {
            console.log("========", res, row)
            var data = res.data.records[0];
            this.editPatientVisible = true;
            this.$nextTick(() => {
              this.$refs["editPatientRef"].init(data)
            })
          }
        }).catch((error) => {
          console.log(error);
        })
      }
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.formData.householderIdcard = this.pInfo.idcard;
      this.listLoading = true;
      turnToContactList(this.formData).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.relationData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 删除联系人
    delContactPatient(value) {
      this.$confirm("此操作将删除该联系人信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const patientData = value;
          this.listLoading = true;
          delContactList(patientData).then((res) => {
            this.listLoading = false;
            if (res.msg == "success") {
              this.$message({
                message: "删除成功！",
                type: "success",
              });
              // 更新视图列表
              this.getList();
              console.log("删除操作！");
            } else {
              this.$message({
                message: "删除失败！",
                type: "error",
              });
              console.log("删除操作！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 更新视图
    update() {
      this.getList();
    },
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    getStandardDate(dateString) {
      if (dateString != null) {
        const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
        return formattedDate;
      } else {
        return dateString;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.addContact {
  position: absolute;
  right: 0;
  top: 5px;
}

// ::v-deep {
//   .el-dialog {
//     margin-top: 5vh !important;
//   }

//   .el-dialog__header {
//     padding: 20px !important;
//     padding-bottom: 10px !important;
//   }

//   .el-dialog__body {
//     text-align: initial !important;
//     padding: 25px 25px 30px !important;
//   }

//   .el-dialog__footer {
//     text-align: end;
//   }
// }</style>